import { AiFillSafetyCertificate } from 'react-icons/ai';
import { Focus } from '../types/profile';

import { LuNetwork, LuTrendingUp } from 'react-icons/lu';

const Scale = LuNetwork as React.ComponentType<{
  size?: number;
  color?: string;
}>;

const Safe = AiFillSafetyCertificate as React.ComponentType<{
  size?: number;
  color?: string;
}>;

const Performance = LuTrendingUp as React.ComponentType<{
  size?: number;
  color?: string;
}>;

export const techSkills = [
  'React native',
  'TypeScript',
  'JavaScript',
  'Redux/Zustand',
  'React',
  'Node.js',
  'Rest API',
  'CI/CD Pipeline',
  'Performance Optimization',
  'Clean Architecture',
];
export const leaderShipSkills = [
  'Cross-functional Team',
  'Collaboration',
  'Delivery',
  'Team Leadership',
  'Code reviews',
  'Technical Debt',
  'Agile/Scrum',
  'Communication',
  'Monitoring Developers',
  'Technical Debt',
];

export const focuses: Focus[] = [
  {
    title: 'Scalable Architecture',
    desc: 'Design scalable architecture for mobile applications',
    icon: Scale,
  },
  {
    title: 'Performance Optimization',
    desc: 'Enhancing app speed and responsiveness.',
    icon: Safe,
  },
  {
    title: 'Scalable Architecture',
    desc: 'Design scalable architecture for mobile applications',
    icon: Performance,
  },
  {
    title: 'Scalable Architecture',
    desc: 'Design scalable architecture for mobile applications',
    icon: Scale,
  },
  {
    title: 'Scalable Architecture',
    desc: 'Design scalable architecture for mobile applications',
    icon: Scale,
  },
];
